module.exports = __webpack_public_path__ + "static/1-db95703aed2334e4019c0b941a9a6c9f.jpg";